import { Link } from 'react-router-dom';

export const SimpleFlexiblePricing = () => {
  const handleFsboClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    window.location.hash = '#fsbo-question';

    // Find the FSBO question element
    const fsboQuestion = document.getElementById('fsbo-question');
    if (fsboQuestion) {
      // Scroll to the question
      fsboQuestion.scrollIntoView({ behavior: 'smooth', block: 'center' });

      // Add highlight class (permanently - stays highlighted)
      fsboQuestion.classList.add('highlight-fsbo');
    }
  };

  const handleLeadsClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    window.location.hash = '#leads-question';

    // Find the leads question element
    const leadsQuestion = document.getElementById('leads-question');
    if (leadsQuestion) {
      // Scroll to the question
      leadsQuestion.scrollIntoView({ behavior: 'smooth', block: 'center' });

      // Add highlight class (permanently - stays highlighted)
      leadsQuestion.classList.add('highlight-fsbo');
    }
  };
  const plans = [
    {
      id: 'essential',
      label: 'Essential',
      price: 2950,
      discountedPrice: 1475, // 50% off
      showDiscount: true,
      description:
        'Perfect for individual agents getting started with lead generation.',
      features: {
        'Leads & Listings': ['0 FSBO listings', '15-30 buyer/rental leads'],
        'Tools & Features': ['24/7 lead routing'],
        Support: ['Dedicated account manager']
      },
      primaryCta: 'Start Trial Now',
      secondaryCta: 'Schedule Call »',
      highlight: false
    },
    {
      id: 'premium',
      label: 'Premium',
      price: 4950,
      showDiscount: false,
      description:
        'Ideal for growing teams that need more leads and dedicated support.',
      features: {
        'Leads & Listings': ['8-10 FSBO listings', '40-60 buyer/rental leads'],
        'Tools & Features': ['24/7 lead routing'],
        Support: ['Dedicated account manager']
      },
      primaryCta: null,
      secondaryCta: 'Schedule Call',
      highlight: false
    },
    {
      id: 'elite',
      label: 'Elite',
      price: 8950,
      showDiscount: false,
      description:
        'For top-performing teams and brokerages that demand maximum growth.',
      features: {
        'Leads & Listings': [
          '15-20 FSBO listings',
          '75-120 buyer/rental leads'
        ],
        'Tools & Features': ['24/7 lead routing'],
        Support: ['Dedicated account manager']
      },
      primaryCta: null,
      secondaryCta: 'Schedule Call',
      highlight: false
    }
  ];

  return (
    <section
      id="pricing-1"
      className="gr--whitesmoke pb--40 pb-[40px] inner-page-hero pricing-section pt-[100px] lg:max-xl:pt-[90px] md:max-lg:!mt-[80px] md:max-lg:pt-[50px] sm:max-md:pt-[30px] xsm:max-sm:pt-[20px]"
    >
      <div className="container">
        {/* Value proposition */}
        <div className="flex flex-wrap mx-[calc(-0.5*_1.5rem)] justify-center mb-10">
          <div className="md:w-10/12 w-full flex-[0_0_auto] px-[calc(0.5*_1.5rem)] max-w-full">
            <div className="rounded-xl border border-[#1680fb]/25 bg-white px-6 py-5 text-center shadow-sm md:text-left md:flex md:items-center md:justify-between md:gap-6">
              <p className="text-[#353f4f] text-base md:text-lg leading-relaxed !mb-0 md:flex-1">
                <strong>Individual REALTOR.ca showing-request leads</strong> —
                buy as you go or bundle. We offer <strong>shared</strong> leads
                (up to <strong>two</strong> agents) and{' '}
                <strong>exclusive</strong> leads (<strong>one</strong> agent
                only), depending on inventory and offer.
              </p>
              <p className="text-slate-500 text-sm mt-3 md:mt-0 md:max-w-xs md:text-right !mb-0">
                Buy as you go with wallet pricing; scale with plans below if you
                prefer a bundle.
              </p>
            </div>
          </div>
        </div>
        {/* SECTION TITLE */}
        <div className="flex flex-wrap mx-[calc(-0.5*_1.5rem)] justify-center">
          <div className="md:w-10/12 lg:max-xl:w-8/12 xl:w-8/12 w-full flex-[0_0_auto] px-[calc(0.5*_1.5rem)] max-w-full">
            <div className="section-title !text-center mb--70 mb-[70px] lg:max-xl:!mb-[60px] md:max-lg:!mb-[50px]">
              {/* Title */}
              <h2 className="s-52 w--700 xl:!text-[3.25rem] lg:max-xl:!text-[3rem] md:max-lg:!text-[2.79411rem] sm:max-md:!text-[2.375rem] xsm:max-sm:!text-[2.0625rem] !font-bold !tracking-[-0.5px] leading-[1.25] font-Jakarta sm:max-md:!leading-[1.35] xsm:max-sm:!leading-[1.35]">
                Plans &amp; bundles
              </h2>
              <p className="text-slate-600 mt-4 max-w-2xl mx-auto text-base leading-relaxed">
                Prefer pay-as-you-go per lead in the app? Start with a wallet.
                These tiers wrap volume, support, and mere postings for teams
                that want a predictable monthly package.
              </p>
            </div>
          </div>
        </div>
        {/* END SECTION TITLE */}
        {/* PRICING TABLES */}
        <div className="pricing-1-wrapper">
          <div className="flex flex-wrap mx-[calc(-0.5*_1.5rem)] row-cols-1 row-cols-md-3">
            {plans.map((plan, index) => (
              <div
                key={plan.id}
                className={`col lg:w-4/12 xl:w-4/12 flex-[0_0_auto] w-full max-w-full px-[calc(0.5*_1.5rem)] ${
                  plan.highlight ? 'relative z-10' : ''
                }`}
              >
                <div
                  id={`pt--1-${index + 1}`}
                  className={`p-table pricing-1-table xl:!pt-[50px] xl:!pb-[45px] xl:!px-[38px] lg:max-xl:pt-[40px] lg:max-xl:!pb-[35px] lg:max-xl:px-[25px] md:max-lg:pt-[30px] md:max-lg:!pb-[25px] md:max-lg:px-[25px] sm:max-md:pt-[35px] sm:max-md:!pb-[40px] sm:max-md:px-[30px] xsm:max-sm:px-[40px] xsm:max-sm:py-[35px] bg--white-100 block-shadow rounded-[12px] wow fadeInUp xl:!mb-[50px] lg:max-xl:!mb-[40px] md:max-lg:!mb-[35px] sm:max-md:!mb-[40px] xsm:max-sm:!mb-[40px] shadow-[0_4px_12px_0_rgba(0,0,0,0.08)] transition-all duration-300 ease-in-out hover:shadow-[0_8px_24px_0_rgba(0,0,0,0.12)] hover:scale-[1.02] hover:border-2 hover:border-[#1680fb] border-t-4 border-[#1680fb]`}
                >
                  {/* TABLE HEADER */}
                  <div className="pricing-table-header relative">
                    {/* Title */}
                    <div className="flex items-center gap-3 mb--30 xl:!mb-[30px] lg:max-xl:!mb-[25px] md:max-lg:!mb-[20px]">
                      <h5 className="s-24 w--700 xl:!text-[1.5rem] !font-bold sm:max-md:!text-[1.6875rem] xsm:max-sm:!text-[1.5625rem] leading-[1.35] font-Jakarta sm:max-md:!leading-[1.4] xsm:max-sm:!leading-[1.4]">
                        {plan.label}
                      </h5>
                      {plan.id === 'premium' && (
                        <span className="inline-flex items-center px-3 py-1 rounded-md text-xs font-semibold border border-[#1680fb] text-[#1680fb] bg-transparent font-Jakarta">
                          ✨ Popular
                        </span>
                      )}
                      {plan.id === 'essential' && (
                        <span className="inline-flex items-center px-3 py-1 rounded-md text-xs font-semibold border border-[#1680fb] text-[#1680fb] bg-transparent font-Jakarta">
                          ✨ 50% Off First Month
                        </span>
                      )}
                    </div>
                    {/* Price */}
                    <div className="price">
                      {plan.showDiscount ? (
                        <div className="relative">
                          {/* Original price crossed out */}
                          <div className="mb-5 ">
                            {/* <sup className="color--grey xl:!text-[1.5rem] font-semibold top-[-5px] tracking-[-1px] right-[2px] font-Jakarta lg:max-xl:!text-[1.4rem] md:max-lg:!text-[1.3rem] sm:max-md:!text-[1.4rem] xsm:max-sm:!text-[1.3rem] line-through opacity-60">
                              $
                            </sup>
                            <span className="color--grey xl:!text-[2.25rem] leading-none font-semibold tracking-[-2px] font-Jakarta lg:max-xl:!text-[2.1rem] md:max-lg:!text-[1.8rem] sm:max-md:!text-[2.1rem] xsm:max-sm:!text-[2rem] line-through opacity-60">
                              {plan.price.toLocaleString()}
                            </span>
                            <sup className="validity color--grey tracking-[-1px] right-[2px] xl:!text-[1.1rem] !font-normal left-0 -top-[2px] line-through opacity-60">
                              /mo
                            </sup> */}
                            {/* <span className="w-full text-center text-[0.875rem] font-semibold border border-[#1680fb] text-[#1680fb] bg-transparent rounded-md px-4 py-2 inline-block font-Jakarta">
                              ✨ 50% OFF FIRST MONTH
                            </span> */}
                          </div>
                          {/* Discounted price */}
                          <div>
                            <sup className="color--black xl:!text-[2.05rem] font-semibold top-[-5px] tracking-[-1px] right-[2px] font-Jakarta lg:max-xl:!text-[2rem] lg:max-xl:right-[2px] lg:max-xl:-top-1 md:max-lg:!text-[2.125rem] md:max-lg:-top-[2px] sm:max-md:!text-[2.15rem] sm:max-md:-top-1 xsm:max-sm:!text-[2rem] xsm:max-sm:top-[-5px]">
                              $
                            </sup>
                            <span className="color--black xl:!text-[3rem] leading-none font-semibold tracking-[-2px] font-Jakarta lg:max-xl:!text-[2.85rem] lg:max-xl:tracking-[-1.5px] md:max-lg:!text-[2.45rem] md:max-lg:tracking-[-1.5px] sm:max-md:!text-[2.875rem] sm:max-md:tracking-[-1.5px] xsm:max-sm:!text-[2.75rem]">
                              {plan.discountedPrice?.toLocaleString()}
                            </span>
                            <sup className="validity color--grey tracking-[-1px] right-[2px] xl:!text-[1.4rem] !font-normal left-0 -top-[2px] font-Jakarta lg:max-xl:!text-[1.45rem] md:max-lg:!text-[1.2rem] sm:max-md:!text-[1.4375rem] xsm:max-sm:!text-[1.3125rem]">
                              &nbsp;/&ensp;first month
                            </sup>
                          </div>
                          <p className="color--grey text-[0.875rem] mt-2 mb-0">
                            Renews at ${plan.price.toLocaleString()}/month
                          </p>
                        </div>
                      ) : (
                        <>
                          <sup className="color--black xl:!text-[2.05rem] font-semibold top-[-5px] tracking-[-1px] right-[2px] font-Jakarta lg:max-xl:!text-[2rem] lg:max-xl:right-[2px] lg:max-xl:-top-1 md:max-lg:!text-[2.125rem] md:max-lg:-top-[2px] sm:max-md:!text-[2.15rem] sm:max-md:-top-1 xsm:max-sm:!text-[2rem] xsm:max-sm:top-[-5px]">
                            $
                          </sup>
                          <span className="color--black xl:!text-[3rem] leading-none font-semibold tracking-[-2px] font-Jakarta lg:max-xl:!text-[2.85rem] lg:max-xl:tracking-[-1.5px] md:max-lg:!text-[2.45rem] md:max-lg:tracking-[-1.5px] sm:max-md:!text-[2.875rem] sm:max-md:tracking-[-1.5px] xsm:max-sm:!text-[2.75rem]">
                            {plan.price.toLocaleString()}
                          </span>
                          <sup className="validity color--grey tracking-[-1px] right-[2px] xl:!text-[1.4rem] !font-normal left-0 -top-[2px] font-Jakarta lg:max-xl:!text-[1.45rem] md:max-lg:!text-[1.2rem] sm:max-md:!text-[1.4375rem] xsm:max-sm:!text-[1.3125rem]">
                            &nbsp;/&ensp;month
                          </sup>
                        </>
                      )}
                      {/* <p className="color--grey my-[25px] lg:max-xl:!mt-[20px] lg:max-xl:!mb-[15px] md:max-lg:!text-[0.9075rem] md:max-lg:my-[14px]">
                        {plan.description}
                      </p> */}
                    </div>
                    {/* Buttons */}
                    {plan.primaryCta ? (
                      <div className="flex items-center gap-3 xl:!mt-[14px] md:max-lg:!mt-3 sm:max-md:!mt-3 xsm:max-sm:!mt-3">
                        <Link
                          to="/schedule-call"
                          className="btn r-04 !rounded-[4px] btn--blue-400 hover--blue-500 flex-1"
                        >
                          {plan.primaryCta} &#187;
                        </Link>
                        {/* <Link
                            to="/schedule-call"
                            className="text-blue-600 font-medium hover:text-blue-700"
                          >
                          {plan.secondaryCta}
                        </Link> */}
                      </div>
                    ) : (
                      <div className="text-center mt-6 mb-[-20px]">
                        <p className="text-md text-gray-700 more-questions-txt bg--white-400 rounded-[100px] inline-block px-[46px] py-2 lg:max-xl:px-11 lg:max-xl:py-[18px] md:max-lg:px-[42px] md:max-lg:py-[18px] sm:max-md:px-[42px] sm:max-md:py-[18px] xsm:max-sm:px-9 xsm:max-sm:py-[18px]">
                          {/* Curious to learn more? &nbsp; */}
                          <Link
                            to="/schedule-call"
                            className="text-blue-600 font-medium hover:text-blue-700"
                          >
                            Schedule a Call &#187;
                          </Link>
                        </p>
                      </div>
                    )}
                  </div>
                  {/* END TABLE HEADER */}
                  {/* PRICING FEATURES */}
                  <ul className="pricing-features color--black ico-10 ico--green mt--10 mt-[25px]">
                    {Object.entries(plan.features).map(
                      ([category, features]) => (
                        <li key={category} className="mb-4 last:mb-0">
                          <h6 className="text-[0.875rem] font-semibold text-[#353f4f] mb-2 font-Jakarta uppercase tracking-wider">
                            {category}
                          </h6>
                          <ul className="space-y-1">
                            {features.map((feature, featureIndex) => {
                              const isZeroFsbo =
                                plan.id === 'essential' &&
                                feature.includes('0 FSBO');
                              const isFsboListing =
                                feature.includes('FSBO listings');
                              const isBuyerTenantLeads =
                                feature.includes('buyer/rental leads');
                              return (
                                <li
                                  key={featureIndex}
                                  className="px-[8px] py-[8px] md:max-lg:px-0 md:max-lg:py-1 sm:max-md:px-[8px] sm:max-md:py-[8px] xsm:max-sm:px-[8px] xsm:max-sm:py-[8px]"
                                >
                                  <p className="text-[0.875rem] inline-flex items-center gap-1 flex-wrap">
                                    {isZeroFsbo ? (
                                      <span className="text-[#666] font-semibold">
                                        —
                                      </span>
                                    ) : (
                                      <span className="flaticon-check"></span>
                                    )}{' '}
                                    <span>{feature}</span>
                                    {isFsboListing && (
                                      <a
                                        href="#fsbo-question"
                                        onClick={handleFsboClick}
                                        className="inline-flex items-center text-blue-600 hover:text-blue-700 transition-colors"
                                        aria-label="Learn more about FSBO listings"
                                      >
                                        <svg
                                          className="w-4 h-4"
                                          fill="none"
                                          stroke="currentColor"
                                          viewBox="0 0 24 24"
                                        >
                                          <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                          />
                                        </svg>
                                      </a>
                                    )}
                                    {isBuyerTenantLeads && (
                                      <a
                                        href="#leads-question"
                                        onClick={handleLeadsClick}
                                        className="inline-flex items-center text-blue-600 hover:text-blue-700 transition-colors"
                                        aria-label="Learn more about where leads come from"
                                      >
                                        <svg
                                          className="w-4 h-4"
                                          fill="none"
                                          stroke="currentColor"
                                          viewBox="0 0 24 24"
                                        >
                                          <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                          />
                                        </svg>
                                      </a>
                                    )}
                                  </p>
                                </li>
                              );
                            })}
                          </ul>
                        </li>
                      )
                    )}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* PRICING TABLES */}
      </div>
      {/* End container */}
    </section>
  );
};
